import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState: {} = {
  procedureQuestionnaire: null,
  error: false,
  loading: false,
};
const fetchProcedureQuestionnaireFailed = (state, action) => {
  return updateObject(state, { error: true, loading: false });
};
const procedureQuestionnaire = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PROCEDURE_QUESTIONNAIRE_STARTED:
      return {
        procedureQuestionnaire: null,
        loading: true,
        error: false,
      };
    case actionTypes.FETCH_PROCEDURE_QUESTIONNAIRE_SUCCESS:
      // return fetchProcedureQuestionnaireSuccess(state, action);
      return {
        procedureQuestionnaire: action.procedureQuestionnaire,
        error: false,
        loading: false,
      };

    case actionTypes.FETCH_PROCEDURE_QUESTIONNAIRE_FAILED: {
      return fetchProcedureQuestionnaireFailed(state, action);
    }
    default:
      return state;
  }
};
export default procedureQuestionnaire;
